import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-cifris24',
  templateUrl: './home-cifris24.component.html',
  styleUrls: ['./home-cifris24.component.css']
})
export class HomeCifris24Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
